module.exports = {
  DEBUG: true,
  AUTH_USER_NAME: process.env.REACT_APP_USER_AUTHEN,
  AUTH_PASSWORD: process.env.REACT_APP_PASSWORD_AUTHEN,
};
